'use client';

import { useEffect } from 'react';
import { preload } from 'react-dom';

let started = false;

/** Boots the three.js scene once the server-rendered shell is on screen. */
export default function Experience() {
  // start the heavy downloads alongside the JS chunk instead of after it
  preload('/assets/scene.glb', { as: 'fetch', crossOrigin: 'anonymous' });
  preload('/assets/scatter.json', { as: 'fetch', crossOrigin: 'anonymous' });
  preload('/assets/scene.json', { as: 'fetch', crossOrigin: 'anonymous' });

  useEffect(() => {
    if (started) return; // effects run twice under StrictMode in dev; the scene owns the page for good
    started = true;
    import('../main.js').then(({ start }) => start());
  }, []);

  return null;
}
